(function (Drupal) {
  Drupal.behaviors.menuFlotanteScroll = {
    attach: function (context, settings) {
      const menu = context.querySelector(".header");
      const toggler = context.querySelector(".navbar-toggler");
      const stickyElements = context.querySelectorAll(".sticky-top-menu");
      const root = document.documentElement;
      if (!menu) return;

      // --- Función para calcular la altura del header ---
      const updateHeaderOffset = () => {
        const headerHeight = menu.getBoundingClientRect().height;
        // Aplica la variable CSS globalmente
        root.style.setProperty("--scroll-offset", `${headerHeight}px`);
      };

      // --- Scroll visual del header ---
      if (!menu.hasScrollListener) {
        const onScroll = () => menu.classList.toggle("scrollon", window.scrollY > 0);
        window.addEventListener("scroll", onScroll);
        onScroll();
        menu.hasScrollListener = true;
      }

      // --- Toggle menú hamburguesa ---
      if (toggler && !toggler.hasClickListener) {
        toggler.addEventListener("click", () => {
          menu.classList.toggle("menu-open");
          updateHeaderOffset();
          updateStickyOffset();
        });
        toggler.hasClickListener = true;
      }

      // --- Actualizar sticky offsets ---
      function updateStickyOffset() {
        const h = menu.getBoundingClientRect().height;
        stickyElements.forEach(el => (el.style.top = `${h + 16}px`));
      }

      // --- Eventos dinámicos ---
      if (!menu.hasResizeListener) {
        window.addEventListener("resize", () => {
          updateHeaderOffset();
          updateStickyOffset();
        });
        menu.hasResizeListener = true;
      }

      // Inicializar al cargar
      updateHeaderOffset();
      updateStickyOffset();

      // --- Scroll suave para anclas en la misma página ---
      if (!menu.hasAnchorScrollListener) {
        context.querySelectorAll('a[href*="#"]').forEach(anchor => {
          anchor.addEventListener("click", function (e) {
            const href = this.getAttribute("href");
            const [base, hash] = href.split("#");

            // Solo aplicar si es el mismo documento
            const samePage =
              (!base || base === "" ||
                base === window.location.pathname.replace(/^\//, "") ||
                base === window.location.pathname);

            if (hash && samePage) {
              const target = document.getElementById(hash);
              if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: "smooth" });
                menu.classList.remove("menu-open");
                toggler?.classList.remove("is-active");
              }
            }
          });
        });
        menu.hasAnchorScrollListener = true;
      }
    },
  };
})(Drupal);
